<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">任务池</h1>
        </div>
        <div class="content">
            <div>
                <form @submit.prevent="query" class="form-group-list-form">
                <div class="form-group-list">
                    <div class="form-group">
                        <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;" label="任务单号" type="text" id="location"
                                    v-model="form.number" placeholder="请输入任务单号"
                                    ref="inputField"
                                    @update:modelValue="(value) => handleModelValueUpdate('number', value)"
                        />
                    </div>
                    <div class="form-group">
                        <SelectField labelWidth="32%" label="类型" :options="typeList" v-model="form.type" id="type" placeholder="任务类型"
                                     ref="SelectField"
                                     @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                        />
                    </div>
                    <div class="form-group">
                        <SelectField labelWidth="32%" label="状态" :options="statusList" v-model="form.status" id="status" placeholder="任务状态"
                                     ref="SelectFieldS"
                                     @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                        />
                    </div>
                    <div class="form-group">
                        <a-space>
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                </div>
                <div>
                    <ButtonField text="新建任务" @click="$router.push('/manage/map?page=task&action=add')" secondary />
                </div>
            </form>
            </div>
            <div style="margin-top: 1rem;">
                <Tablelist
                    :showCheckbox="showCheckbox"
                    :list="list"
                    :columns="tableColumns"
                    :totalSize="totalSize"
                    :totalPages="totalPages"
                    :pageNum="pageNum"
                    :pageSize="pageSize"
                    @page-change="onChange"
                >
                    <template #template-type="{ item }">
                        <DataDictFinder dictType="taskType" :dictValue="item.type" />
                    </template>
                    <template #template-status="{ item }">
                        <DataDictFinder dictType="taskStatus" :dictValue="String(item.status)" />
                    </template>
                    <template v-slot:actions="{ item }">
                        <a-space>
                            <a href="#" v-if="item.status === 'reviewing'"
                                @click.prevent="$router.push('/manage/task-review?id=' + item.id + '&type=' + item.type)">审核</a>
                            <a v-else href="#"
                                @click.prevent="$router.push( '/manage/map?page=task&action=edit&id=' + item.id + '&type=' + item.type )">编辑</a>
                            <a href="#" @click.prevent="deleteText(item)" class="danger">删除</a>
                        </a-space>
                    </template>
                </Tablelist>
            </div>
        </div>
    </div>
</template>
<script>
import { fetchList, remove } from "../api/task";
import { mapGetters } from "vuex";
import Tablelist from "@/components/water-affairs-style/table-list.vue";

export default {
    components: {Tablelist},
    data() {
        return {
            form: {},
            loading: false,
            totalSize: 0,
            totalPages: 0,
            pageNum: 1,
            pageSize: 10,
            list:[
                {number:1,name:'-',type:'-',taskTime:'2025-03-10',initiatorName:'-',executorName:'-',status:'reviewing'}
            ],
            showCheckbox:false,
            total: 0,
            tableColumns: [
                {
                    key: 'number',
                    title: '任务单号',
                    field: 'number',
                    infotype: 'text'
                },
                {
                    key: 'name',
                    title: '任务名称',
                    field: 'name',
                    infotype: 'text'
                },
                {
                    key: 'type',
                    title: '任务类型',
                    field: 'type',
                    infotype: 'template'
                },
                {
                    key: 'taskTime',
                    title: '任务日期',
                    field: 'taskTime',
                    ellipsis: true,
                    infotype: 'text'
                },
                {
                    key: 'initiatorName',
                    title: '发起人',
                    field: 'initiatorName',
                    ellipsis: true,
                    infotype: 'text'
                },
                {
                    key: 'executorName',
                    title: '执行人',
                    field: 'executorName',
                    ellipsis: true,
                    infotype: 'text'
                },
                {
                    key: 'status',
                    title: '状态',
                    field: 'status',
                    infotype: 'template'
                },
                {
                    key: 'actions',
                    title: '操作',
                    infotype: 'template'
                }
            ]
        };
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        typeList() {
            return this.findDataDict("taskType");
        },
        statusList() {
            return this.findDataDict("taskStatus");
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        getList() {
            this.loading = true;
            fetchList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...this.form,
            })
                .then((res) => {
                    this.loading = false;
                    if (Array.isArray(res.list)) {
                        this.list = res.list;
                        this.totalSize = res.totalSize;
                        this.totalPages = res.totalPages;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        deleteText(text) {
            const that = this;

            this.$confirm({
                title: "确定要删除吗？",
                onOk() {
                    remove(text).then(() => {
                        that.getList();
                    });
                },
            });
        },

        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getList();
        },

        query() {
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
        reset() {
            this.form = {
                number: '',
                type: null,
                status: null,
            };
            this.$refs.inputField.reset();
            this.$refs.SelectField.reset();
            this.$refs.SelectFieldS.reset();
            this.pageNum = 1;
            this.pageSize = 10;
            this.getList();
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    background: #0a0e27;
    color: #fff;
    overflow-x: hidden;
}

/* 主内容区 */
.main-container {
    padding:2rem 0;
    width: 80%;
    margin: auto;
}

/* 页面标题 */
.page-header {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
.form-group-list-form{
    display: flex;
    justify-content: space-between;
}
.form-group-list{
    display: flex;
    justify-content: start;
    align-items: center;
}
.form-group{
    margin-right: 1rem;
}
</style>